import React, { useEffect, useState } from 'react'
import Network from '../utils/Network';
import { ArenaQuestResponse, ArenaRewardDetails } from '../types/pages/MarketPlace';

type Props = {
  isEmber?: boolean;
  isEventShop?: boolean;
}

const useArenaShop = (props?: Props) => {
  const { isEmber, isEventShop } = props || {}
  const [data, setData] = useState<ArenaQuestResponse>();
  const [loading, setLoading] = useState(false);
  const axios = new Network()
  const handleGetShopData = async () => {
    setLoading(true);
    const res = await axios.CallApi<ArenaQuestResponse>({
      url: isEventShop ? "/quest/eventshops" : isEmber ? "/quest/embershops" : "/quest/arenashops",
      method: "get",
    });
    if (res.ok)
      setData({
        ...res.data,
        rewards: res.data.rewards.map((d) => ({
          ...d,
          rewards: d.rewards && typeof d.rewards == "string" ? JSON.parse(d.rewards as any) as ArenaRewardDetails[] : d.rewards ?? undefined,
        })),
      });
    setLoading(false);
  };

  return (
    {
      getShopData: handleGetShopData,
      data,
      loading,
    }
  )
}

export default useArenaShop